export default __webpack_public_path__ + "static/media/spinner.f731650a.JPG";